import React from "react";

import { useSelector } from "react-redux";

import { Body2 } from "Cobalt/BodyText";
import Icon from "Common/Icon";
import InfoPopover from "Common/InfoPopover";
import { inABTest } from "Common/Selectors";

import makeBem from "Utils/makeBem";

const bem = makeBem("DentalMinimumWarning");

const DentalMinimumWarning = ({ plan }) => {
  const minimumRequirement = plan.dental_minimum_enrollment_requirement;
  const employeeProfile = useSelector((state) => state.employeeProfile);

  // There are 2 or fewer employees, and the plan requires more than 2 people OR
  // there are 7 or fewer employees, and the plan requires more than 5 people
  const belowRequirement = (minimumRequirement >= 2 && employeeProfile.length <= 2) || (minimumRequirement >= 5 && employeeProfile.length <= 7);

  const infoText = `
    ${plan.carrier} requires a minimum of ${minimumRequirement} employees to enroll
    in this dental plan in order to offer it to your employees. If fewer than
    ${minimumRequirement} employees choose to enroll, you will not be able to
    offer this plan.
  `;

  if (belowRequirement) {
    return (
      <>
        <Body2 weight="bold" mr={2} className={bem()}>
          Dental plan eligibility
        </Body2>
        <InfoPopover infoText={infoText} displayComponent={<Icon icon="question-circle" />} />
      </>
    );
  }
  return null;
};

export default DentalMinimumWarning;
